<template>
  <div class="card px-2 py-3 shadow-sm d-flex">

    <LoadingSpinner v-if="loadingData" />

    <!-- Data table -->
    <div class="col-12 mt-3" v-else>
      <div class="row">
      <div class="col-12">
        <Table
          :key="key"
          :headers="headers"
          :cols="cols"
          :data="data"
          :model="[]"
          :checkbox="false"
          :notselect="true"          
          @openUser="openUser"
          @openLogin="openLogin"
        />
      </div>
      
    </div>
    </div>
  </div>
</template>

<script>
import { usersService } from "@/_services";
import IndustrySearch from "@/components/AccountCreation/Steps/Campaign/search/IndustrySearch.vue";
import moment from 'moment';
import { mapState} from "vuex";
import Table from "@/components/Common/Table.vue";
import LoadingSpinner from '../LoadingSpinner.vue';



export default {
  name: 'OliverSalesTeam',

  components: {
    IndustrySearch,
    Table,
    LoadingSpinner
  },

  data() {
    return {
      revenue_ranking: [
        { id: 1, img: '1_novice_closer.png',label: 'Novice Closer', min: 0, max: 15000},
        { id: 2, img: '2_deal_maker.png',label: 'Deal Maker', min: 15001, max: 40000},
        { id: 3, img: '3_sales_navigator.png',label: 'Sales Navigator', min: 40001, max: 80000},
        { id: 4, img: '4_revenue_builder.png',label: 'Revenue Builder', min: 80001, max: 150000},
        { id: 5, img: '5_growth_catalyst.png',label: 'Growth Catalyst', min: 150001, max: 250000},        
        { id: 6, img: '6_campaign_master.png',label: 'Campaign Master', min: 250001, max: 400000},
        { id: 7, img: '7_lead_strategist.png',label: 'Lead Strategist', min: 400001, max: 600000},
        { id: 8, img: '8_deal_architech.png',label: 'Deal Architect', min: 600001, max: 900000},
        { id: 9, img: '9_revenue_guru.png',label: 'Revenue Guru', min: 900001, max: 1200000},
        { id: 10,img: '10_b2b_rainmaker.png', label: 'B2B Rainmaker', min: 1200001, max: 5200000},
      ],
      loadingData: false,
      userOliverSale: ["0"],
      userOliverSales: [{ id: "0", label: "Select option..."}, { id: "all", label: "All"}],
      oliverSalesLoaded: false,
      key: 3232323,
      data: [],
      headers: [
        {
          label: "Photo",
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 1,
        },
        {
          label: "Name",
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 3,
        },
        {
          label: "Creation date",
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 4,
        },
        {
          label: "Badge",
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
        },
        {
          label: "Level",
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
        },
        {
          label: "Active clients",
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
        },
        {
          label: "Clients signed",
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
        },
        {
          label: this.$t("lang.orders.orders") + " sold",
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
        },
        {
          label: "Revenue",
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
        },
        {
          label: "Access",
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
        }
      ],

      cols: [
        [
          {
            value: "avatar",
            type: "image",
            width: "55px"
          }
        ],
        [
          {
            value_label: "name",
            value_emit: "user_id",
            class: "text-primary",
            type: "emit",
            emit: "openUser",
          },
        ],
        [
          {
            value: "creation_date",
          },
        ],
        [
          {
            value: "badge",
            type: "ImageBadge",
            //width: "55px"
          },
        ],
        [
          {
            value: "level",
          },
        ],
        [
          {
            value: "current_clients",
          },
        ],
        [
          {
            value: "total_signed",
          },
        ],
        [
          {
            value: "total_orders",
          },
        ],
        [
          {
            value: "total",
            format: "money",
            simbol: '€'
          },
        ],
        [
          {
            value_label: "login",
            value_emit: "email",
            class: "text-primary",
            type: "emit",
            emit: "openLogin",
          },
        ],
        // [
        //   {
        //     value_label: "client_name",
        //     value_emit: "client_id",
        //     class: "text-primary",
        //     type: "emit",
        //     emit: "openClient",
        //   },
        // ], 
        // [
        //   {
        //     value_label: "target_name",
        //     value_emit: "id",
        //     class: "text-primary",
        //     type: "emit",
        //     emit: "openTarget",
        //   },
        // ],
      ],
     
    };
  },

  created() {
    this.init()
  },

  computed: {
    ...mapState({
      user: (state) => state.authentication.user,
    }),
    isUserOliverSale() {
      return (this.user.role_id == 1 && this.user.user_constraint_id == 2);
    },
  },


  methods: {

    init(){
      this.getData()
    },

    openLogin(email){
      let url = '/login?user=' + email + '&pass=m0bL$,6RD&g0]?b_V';
      window.open(url, "_blank");
    },

    openUser(user_id) {
      let url = "/users/" + user_id;
      window.open(url, "_blank");
    },

    openTarget(target_id) {
        let url = "/orders/" + target_id;
        window.open(url, "_blank");
    },
    openClient(client_id) {
      let url = "/clients/" + client_id;
      window.open(url, "_blank");
    },

    getData(){
      this.data = []
       this.loadingData = true
       usersService.getOliverSalesTeam()
          .then( res => {
            if (res.result){
             res.result.forEach(element => {
                if(element.avatar == null){
                  element.avatar = require('@/assets/images/emptyperson.png');
                }
             });
             this.data = res.result.map( el => {
               const badge = this.revenue_ranking.find(e => (Number(el.total) >= e.min && Number(el.total) <= e.max )).img
               const level = this.revenue_ranking.find(e => (Number(el.total) >= e.min && Number(el.total) <= e.max )).label
              return {
                ...el,
                badge,
                level,
                login: 'Login'
              }
             })
             this.loadingData = false
            }
            
          })
          .catch( err => console.error(err))      

    },
  },

};
</script>
